module.exports = __webpack_public_path__ + "img/5.d684bcb4.png";